// ─── CALENDAR "RECENTLY DELETED" TRASH ──────────────────────────────────────
// A plain localStorage-backed 30-day trash for tasks/events/reminders,
// shared by every delete code path (List view, the calendar grid inside
// CalendarTab, and the Week-block popover mounted at the App root) so a
// delete from any of them lands in the same "Recently Deleted" panel.
// CalendarTab.jsx owns the React state that actually renders that panel —
// this module only reads/writes the underlying localStorage key, so a
// caller with no access to that component's state (like App.jsx) can still
// append to the trash correctly.
import { load, save } from "./storage";

export const DELETED_ITEMS_KEY = "clarity_deletedItems";
export const TRASH_RETENTION_MS = 30 * 24 * 60 * 60 * 1000;

// entries: [{ id, type, item }] — returns the updated (already-pruned) list.
export function softDeleteCalendarItems(entries) {
  if (!entries || !entries.length) return load(DELETED_ITEMS_KEY, []);
  const now_ = new Date().toISOString();
  const cutoff = Date.now() - TRASH_RETENTION_MS;
  const prev = load(DELETED_ITEMS_KEY, []);
  const next = [
    ...entries.map(e => ({ id: e.id, type: e.type, item: e.item, deletedAt: now_ })),
    ...prev,
  ].filter(d => new Date(d.deletedAt).getTime() >= cutoff);
  save(DELETED_ITEMS_KEY, next);
  return next;
}
